import { useState } from 'react';
import { usePresence } from '@accounts/session';
import { Refusal } from '@accounts/transport';
import { Button, Callout } from '@beyond-js/ui/react';
import { Problem } from './problem';

/**
 * The account's deletion in its grace (E8, ACC-08): when it takes effect, and **Keep my account**.
 * Nothing when no deletion is pending.
 */
export function Deletion() {
	const { text, date, identity, accounts, refresh } = usePresence();
	const [busy, setBusy] = useState(false);
	const [failure, setFailure] = useState<unknown>();
	const [kept, setKept] = useState(false);
	const when = identity?.account.deletion;
	if (kept) return <Callout tone="success" live title={text('data.deletion.kept')} />;
	if (!when) return null;

	async function keep() {
		setBusy(true);
		setFailure(undefined);
		try {
			await accounts.keep();
			setKept(true);
			await refresh();
		} catch (error) {
			if (!(Refusal.is(error) && error.quiet)) setFailure(error);
			// Nothing came back, so the account may be kept: standing is read again
			if (Refusal.is(error) && error.unknown) await refresh();
		} finally {
			setBusy(false);
		}
	}

	return (
		<>
			{failure ? <Problem error={failure} /> : null}
			<Callout
				tone="warning"
				live
				title={text('data.deletion', { date: date(when) })}
				actions={
					<Button variant="primary" busy={busy} onClick={() => void keep()}>
						{text('data.deletion.keep')}
					</Button>
				}
			/>
		</>
	);
}
